@if (cps.isPropertyTrue(TMCClientParameters.FEATURES_LINK_TRANSPORTS, false)) {
  <sc-action-icon mat-icon-button iconClass="fa-link"
    (click)="linkTransports()"
    [disabled]="disabled && !asButton"
    dictionaryKey="tmc-yard.ui.control.sac-client.station-transport-details.action.link"
    [matTooltip]="'link transports' | translate: ['tmc.visit.overview.action.linkTransports', translationService.language, translationService.revision]">
  </sc-action-icon>
}
